import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor(private readonly http: HttpClient) { }

  getHistory(type, data){
    if(type == 'product'){
      return this.http.get(`${environment.api_url}history/product`, {params: {...data}});
    } else {
      const dataSend = {
        entityModifiedId: data.entityModifiedId,
        types: data.type
      }
      return this.http.post(`${environment.api_url}history/generic`, {...dataSend});
    }
  }
}
